import { AppServices, Utils } from '@singularsystems/neo-core';
import { configure, isObservableArray, runInAction, untracked } from 'mobx';
import React from 'react';
import { NeoReactTypes } from './Types';
export function runReactSetup(container) {
    Utils.peek = function (target, propertyName) {
        return untracked(function () { return target[propertyName]; });
    };
    Utils.suppressHtmlEncode = function (html) {
        return React.createElement("div", { dangerouslySetInnerHTML: { __html: html } });
    };
    Utils.batchUpdate = runInAction;
    Utils.sortableArray = function (array) {
        if (isObservableArray(array)) {
            return array.slice();
        }
        return array;
    };
    window.addEventListener("beforeunload", function (e) {
        container.get(AppServices.NeoTypes.Routing.PageLeaveHandler).onWindowUnload(container.get(NeoReactTypes.Routing.GlobalRoutingState).currentView, e);
    });
    configure({ enforceActions: "never", useProxies: "never" });
}
